import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
const pizzas = [{
  name: 'Marinara',
  price: '9',
  description: 'San Marzano tomatoes, garlic, oregano, olive oil (no cheese)',
  vegan: true
}, {
  name: 'Bismarck',
  price: '14',
  description: 'Egg, mozzarella, prosciutto cotto, black pepper',
  vegan: false
}, {
  name: 'Ortolana',
  price: '13',
  description: 'Grilled courgettes, aubergines, peppers, cherry tomatoes',
  vegan: true
}, {
  name: 'Bufalina',
  price: '14',
  description: 'Buffalo mozzarella, cherry tomatoes, fresh basil',
  vegan: false
}, {
  name: 'Capricciosa',
  price: '15',
  description: 'Prosciutto cotto, mushrooms, artichokes, black olives',
  vegan: false
}, {
  name: 'Salsiccia e Friarielli',
  price: '15',
  description: 'Italian sausage, friarielli greens, mozzarella',
  vegan: false
}, {
  name: 'Diavola',
  price: '14',
  description: 'Spicy ventricina salami, chili oil, mozzarella',
  vegan: false
}, {
  name: 'Quattro Stagioni',
  price: '16',
  description: 'Four seasons: mushrooms, ham, artichokes, olives',
  vegan: false
}];
export function Menu() {
  return <Section id="menu" className="bg-[#2C2416] text-[#FFF8E7]" data-id="element-90">
      <div className="text-center mb-16" data-id="element-91">
        <span className="text-[#D4735E] uppercase tracking-widest text-sm font-bold" data-id="element-92">
          Le Pizze
        </span>
        <h2 className="text-5xl md:text-7xl text-[#FFF8E7] mt-2 mb-6" data-id="element-93">Menu</h2>
        <div className="w-24 h-1 bg-[#D4735E] mx-auto" data-id="element-94" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-10 max-w-5xl mx-auto" data-id="element-95">
        {pizzas.map((pizza, index) => <motion.div key={pizza.name} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1,
        duration: 0.5
      }} whileHover={{
        scale: 1.02,
        x: 5
      }} className="group cursor-default border-b border-[#FFF8E7]/10 pb-6" data-id="element-96">
            <div className="flex justify-between items-baseline mb-2" data-id="element-97">
              <h3 className="text-3xl text-[#FFF8E7] group-hover:text-[#D4735E] transition-colors duration-300" data-id="element-98">
                {pizza.name}
              </h3>
              <span className="text-2xl font-serif text-[#D4735E]" data-id="element-99">
                £{pizza.price}
              </span>
            </div>
            <p className="text-[#FFF8E7]/70 font-serif text-lg italic" data-id="element-100">
              {pizza.description}
            </p>
          </motion.div>)}
      </div>

      <div className="text-center mt-16 text-[#FFF8E7]/50 italic font-serif" data-id="element-101">
        * Gluten free dough available upon request (+£2)
      </div>
    </Section>;
}